var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"text-paragraph-2",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }